import { render } from "./FolderForm.vue?vue&type=template&id=2805e9c4&scoped=true"
import script from "./FolderForm.vue?vue&type=script&lang=js"
export * from "./FolderForm.vue?vue&type=script&lang=js"

import "./FolderForm.vue?vue&type=style&index=0&id=2805e9c4&lang=css"
import "./FolderForm.vue?vue&type=style&index=1&id=2805e9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2805e9c4"]])

export default __exports__